{
    "data": [
        {
            "description": {
                "name": "Revenues(monthly)",
                "metricLabel": "Revenues Total",
                "description": "All cash that came into a business from customers over the past 12 months.",
                "formula": "ADD(\n  RevenuesCohort,\n  RevenuesNonCohort,\n  RevenuesNonCohortNoCogs,\n  RevenuesNonCohortSeparateCogs,\n  RevenuesNonRecurring,\n)\n",
                "composition": "derived"
            },
            "lineagedValues": [
                {
                    "period": "2020-03",
                    "value": -1922.5800000000017,
                    "accounts": [
                        {
                            "value": -14,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 39222.96,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": -26571.54,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f91a-7103-9854-c09f2f1592eb",
                            "accountName": "Shipping Revenue-264",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": -14560,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2020-04",
                    "value": -20372.929999999997,
                    "accounts": [
                        {
                            "value": -212.5,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 15987.41,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": -18,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f91a-7103-9854-c09f2f1592eb",
                            "accountName": "Shipping Revenue-264",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": -36129.84,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2020-05",
                    "value": -24911.560000000005,
                    "accounts": [
                        {
                            "value": -32.9,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 17995.71,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": -42874.37,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2020-06",
                    "value": -19334.88,
                    "accounts": [
                        {
                            "value": -149.25,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": -11311.89,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 26618.76,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f91a-7103-9854-c09f2f1592eb",
                            "accountName": "Shipping Revenue-264",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": -34492.5,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2020-07",
                    "value": -26263.129999999997,
                    "accounts": [
                        {
                            "value": -590,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 38503.44,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": -64176.57,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2020-08",
                    "value": 23095.1,
                    "accounts": [
                        {
                            "value": -227,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 23322.1,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2020-09",
                    "value": 41617.34,
                    "accounts": [
                        {
                            "value": -317.8,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 37683.5,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 4251.64,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2020-10",
                    "value": 55661.4,
                    "accounts": [
                        {
                            "value": -1228.15,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 55659.05,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 1230.5,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2020-11",
                    "value": 99625.18,
                    "accounts": [
                        {
                            "value": -5244.65,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 95399.15,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 9470.68,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2020-12",
                    "value": 122674.93,
                    "accounts": [
                        {
                            "value": -14815.31,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 126858.43,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 10631.81,
                            "dataAssetId": "0197f5cb-f7c9-7d60-93ea-96b81cb767c3",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2021-01",
                    "value": 39515.08,
                    "accounts": [
                        {
                            "value": -2306.37,
                            "dataAssetId": "0197f5cb-f9ee-7dc0-99ee-8b46deeb9330",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 34687.3,
                            "dataAssetId": "0197f5cb-f9ee-7dc0-99ee-8b46deeb9330",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 7134.15,
                            "dataAssetId": "0197f5cb-f9ee-7dc0-99ee-8b46deeb9330",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2021-02",
                    "value": 26388.219999999998,
                    "accounts": [
                        {
                            "value": -1160.13,
                            "dataAssetId": "0197f5cb-f9ee-7dc0-99ee-8b46deeb9330",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 23608,
                            "dataAssetId": "0197f5cb-f9ee-7dc0-99ee-8b46deeb9330",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 3940.35,
                            "dataAssetId": "0197f5cb-f9ee-7dc0-99ee-8b46deeb9330",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2021-03",
                    "value": 50575.31999999999,
                    "accounts": [
                        {
                            "value": -3065.16,
                            "dataAssetId": "0197f5cb-f9ee-7dc0-99ee-8b46deeb9330",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 49541,
                            "dataAssetId": "0197f5cb-f9ee-7dc0-99ee-8b46deeb9330",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 4099.48,
                            "dataAssetId": "0197f5cb-f9ee-7dc0-99ee-8b46deeb9330",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2021-04",
                    "value": 30222.2,
                    "accounts": [
                        {
                            "value": -3396.18,
                            "dataAssetId": "0197f5cb-f9ee-7dc0-99ee-8b46deeb9330",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 29390,
                            "dataAssetId": "0197f5cb-f9ee-7dc0-99ee-8b46deeb9330",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 4228.38,
                            "dataAssetId": "0197f5cb-f9ee-7dc0-99ee-8b46deeb9330",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2021-05",
                    "value": 23733.71,
                    "accounts": [
                        {
                            "value": -8658.97,
                            "dataAssetId": "0197f5cb-f9ee-7dc0-99ee-8b46deeb9330",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 30063,
                            "dataAssetId": "0197f5cb-f9ee-7dc0-99ee-8b46deeb9330",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 2329.68,
                            "dataAssetId": "0197f5cb-f9ee-7dc0-99ee-8b46deeb9330",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2021-06",
                    "value": 15753.14,
                    "accounts": [
                        {
                            "value": -29142.02,
                            "dataAssetId": "0197f5cb-f9ee-7dc0-99ee-8b46deeb9330",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 35637,
                            "dataAssetId": "0197f5cb-f9ee-7dc0-99ee-8b46deeb9330",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 9258.16,
                            "dataAssetId": "0197f5cb-f9ee-7dc0-99ee-8b46deeb9330",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2021-07",
                    "value": 18617.06,
                    "accounts": [
                        {
                            "value": -12825.38,
                            "dataAssetId": "0197f5cb-f9ee-7dc0-99ee-8b46deeb9330",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 28333,
                            "dataAssetId": "0197f5cb-f9ee-7dc0-99ee-8b46deeb9330",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 3109.44,
                            "dataAssetId": "0197f5cb-f9ee-7dc0-99ee-8b46deeb9330",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2021-08",
                    "value": 47876.009999999995,
                    "accounts": [
                        {
                            "value": -8859.11,
                            "dataAssetId": "0197f5cc-466b-7c30-90d4-c0bfce02382c",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 49773.81,
                            "dataAssetId": "0197f5cc-466b-7c30-90d4-c0bfce02382c",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 6961.31,
                            "dataAssetId": "0197f5cc-466b-7c30-90d4-c0bfce02382c",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2021-09",
                    "value": 34302.39,
                    "accounts": [
                        {
                            "value": -2565.84,
                            "dataAssetId": "0197f5cc-466b-7c30-90d4-c0bfce02382c",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 30873.72,
                            "dataAssetId": "0197f5cc-466b-7c30-90d4-c0bfce02382c",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 5994.51,
                            "dataAssetId": "0197f5cc-466b-7c30-90d4-c0bfce02382c",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2021-10",
                    "value": 97702.95999999999,
                    "accounts": [
                        {
                            "value": -7696.5,
                            "dataAssetId": "0197f5cc-466b-7c30-90d4-c0bfce02382c",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 92330.78,
                            "dataAssetId": "0197f5cc-466b-7c30-90d4-c0bfce02382c",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 13068.68,
                            "dataAssetId": "0197f5cc-466b-7c30-90d4-c0bfce02382c",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2021-11",
                    "value": 152907.57,
                    "accounts": [
                        {
                            "value": -34336.68,
                            "dataAssetId": "0197f5cc-466b-7c30-90d4-c0bfce02382c",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 167842.14,
                            "dataAssetId": "0197f5cc-466b-7c30-90d4-c0bfce02382c",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 19402.11,
                            "dataAssetId": "0197f5cc-466b-7c30-90d4-c0bfce02382c",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2021-12",
                    "value": -375401.14,
                    "accounts": [
                        {
                            "value": 114012.34,
                            "dataAssetId": "0197f5cc-466b-7c30-90d4-c0bfce02382c",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 164213.54,
                            "dataAssetId": "0197f5cc-466b-7c30-90d4-c0bfce02382c",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": -653627.02,
                            "dataAssetId": "0197f5cc-466b-7c30-90d4-c0bfce02382c",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2022-01",
                    "value": 16263.269999999997,
                    "accounts": [
                        {
                            "value": -77977.28,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 65896.87,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 28343.68,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2022-02",
                    "value": 49453.240000000005,
                    "accounts": [
                        {
                            "value": -32434.95,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 67650.75,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 14237.44,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2022-03",
                    "value": 69899.22,
                    "accounts": [
                        {
                            "value": -12977.77,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 62555.72,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 20321.27,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2022-04",
                    "value": 49002.060000000005,
                    "accounts": [
                        {
                            "value": -7431.64,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 42502.33,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 13931.37,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2022-05",
                    "value": 72561.78,
                    "accounts": [
                        {
                            "value": -5633.03,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 63126.35,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 10,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f91a-7103-9854-c09f2f1592eb",
                            "accountName": "Shipping Revenue-264",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 15058.46,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2022-06",
                    "value": 46259.590000000004,
                    "accounts": [
                        {
                            "value": -27195.26,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 51561.16,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 4115,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f91a-7103-9854-c09f2f1592eb",
                            "accountName": "Shipping Revenue-264",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 17778.69,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2022-07",
                    "value": 37089.009999999995,
                    "accounts": [
                        {
                            "value": -26156.78,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 48569.7,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 1540,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f91a-7103-9854-c09f2f1592eb",
                            "accountName": "Shipping Revenue-264",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 13136.09,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2022-08",
                    "value": 93953.2,
                    "accounts": [
                        {
                            "value": -5013.52,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 80965.55,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 18001.17,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2022-09",
                    "value": 37937.06,
                    "accounts": [
                        {
                            "value": -22588.11,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 47515.08,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 25,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f91a-7103-9854-c09f2f1592eb",
                            "accountName": "Shipping Revenue-264",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 12985.09,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2022-10",
                    "value": 167378.1,
                    "accounts": [
                        {
                            "value": -8210.83,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 155490.03,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 20098.9,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2022-11",
                    "value": 121327.93,
                    "accounts": [
                        {
                            "value": -157393.35,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 243868.75,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 76,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f91a-7103-9854-c09f2f1592eb",
                            "accountName": "Shipping Revenue-264",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 34776.53,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2022-12",
                    "value": -122933.76000000001,
                    "accounts": [
                        {
                            "value": -49495.65,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 200735.88,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 78,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f91a-7103-9854-c09f2f1592eb",
                            "accountName": "Shipping Revenue-264",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": -1083009.78,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 808757.79,
                            "dataAssetId": "0197f5cc-4818-7982-a2bc-54c173ae5693",
                            "accountId": "0197f5cb-fd38-77b0-ae46-9147d1af1b80",
                            "accountName": "Shopify Variances-521",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2023-01",
                    "value": -13544.410000000018,
                    "accounts": [
                        {
                            "value": -144332.98,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 86031.15,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 44757.42,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2023-02",
                    "value": 35899.46,
                    "accounts": [
                        {
                            "value": -17263.37,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 33418.14,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 19744.69,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2023-03",
                    "value": 60498.66,
                    "accounts": [
                        {
                            "value": -13394.93,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 58533.43,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 40,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f91a-7103-9854-c09f2f1592eb",
                            "accountName": "Shipping Revenue-264",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 15320.16,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2023-04",
                    "value": 39989.20999999999,
                    "accounts": [
                        {
                            "value": -3013.61,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 33416.52,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 40,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f91a-7103-9854-c09f2f1592eb",
                            "accountName": "Shipping Revenue-264",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 9546.3,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2023-05",
                    "value": 56295.189999999995,
                    "accounts": [
                        {
                            "value": -11350.08,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 58406.7,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 57,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f91a-7103-9854-c09f2f1592eb",
                            "accountName": "Shipping Revenue-264",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 9181.57,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2023-06",
                    "value": 59285.75,
                    "accounts": [
                        {
                            "value": -9331.69,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 43670.04,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 40,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f91a-7103-9854-c09f2f1592eb",
                            "accountName": "Shipping Revenue-264",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 24907.4,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2023-07",
                    "value": 42455.229999999996,
                    "accounts": [
                        {
                            "value": -6250.66,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 39103.2,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 9602.69,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2023-08",
                    "value": 108283.44,
                    "accounts": [
                        {
                            "value": -3199.67,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 89396.26,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 40,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f91a-7103-9854-c09f2f1592eb",
                            "accountName": "Shipping Revenue-264",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 22046.85,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2023-09",
                    "value": 37933.71,
                    "accounts": [
                        {
                            "value": -46068.29,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 65688.97,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 18313.03,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2023-10",
                    "value": 171101.71,
                    "accounts": [
                        {
                            "value": -11861.73,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 158346.14,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 24617.3,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2023-11",
                    "value": 160274.46999999997,
                    "accounts": [
                        {
                            "value": -88637.66,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 220645.52,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 40,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f91a-7103-9854-c09f2f1592eb",
                            "accountName": "Shipping Revenue-264",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 28226.61,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2023-12",
                    "value": 491.39999999990687,
                    "accounts": [
                        {
                            "value": -24665.76,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 200943.38,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": -2036169.26,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 1860383.04,
                            "dataAssetId": "0197f5cc-49ec-7703-b9b3-91d2b0b9215e",
                            "accountId": "0197f5cb-fd38-77b0-ae46-9147d1af1b80",
                            "accountName": "Shopify Variances-521",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2024-01",
                    "value": 123862.9,
                    "accounts": [
                        {
                            "value": -17997.43,
                            "dataAssetId": "0197f5cc-4b9d-75c2-8019-eb5de0ae7ea2",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 82188.78,
                            "dataAssetId": "0197f5cc-4b9d-75c2-8019-eb5de0ae7ea2",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 59671.55,
                            "dataAssetId": "0197f5cc-4b9d-75c2-8019-eb5de0ae7ea2",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2024-02",
                    "value": 107976.89,
                    "accounts": [
                        {
                            "value": -9603.31,
                            "dataAssetId": "0197f5cc-4b9d-75c2-8019-eb5de0ae7ea2",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 82797.89,
                            "dataAssetId": "0197f5cc-4b9d-75c2-8019-eb5de0ae7ea2",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 40,
                            "dataAssetId": "0197f5cc-4b9d-75c2-8019-eb5de0ae7ea2",
                            "accountId": "0197f5cb-f91a-7103-9854-c09f2f1592eb",
                            "accountName": "Shipping Revenue-264",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 34742.31,
                            "dataAssetId": "0197f5cc-4b9d-75c2-8019-eb5de0ae7ea2",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2024-03",
                    "value": 78329.63,
                    "accounts": [
                        {
                            "value": -6374.3,
                            "dataAssetId": "0197f5cc-4b9d-75c2-8019-eb5de0ae7ea2",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 59884.61,
                            "dataAssetId": "0197f5cc-4b9d-75c2-8019-eb5de0ae7ea2",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 24819.32,
                            "dataAssetId": "0197f5cc-4b9d-75c2-8019-eb5de0ae7ea2",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2024-04",
                    "value": 61564.369999999995,
                    "accounts": [
                        {
                            "value": -2280.05,
                            "dataAssetId": "0197f5cc-4b9d-75c2-8019-eb5de0ae7ea2",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 45851.83,
                            "dataAssetId": "0197f5cc-4b9d-75c2-8019-eb5de0ae7ea2",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 17992.59,
                            "dataAssetId": "0197f5cc-4b9d-75c2-8019-eb5de0ae7ea2",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2024-05",
                    "value": 84930.70999999999,
                    "accounts": [
                        {
                            "value": -2693.42,
                            "dataAssetId": "0197f5cc-4b9d-75c2-8019-eb5de0ae7ea2",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 67985.67,
                            "dataAssetId": "0197f5cc-4b9d-75c2-8019-eb5de0ae7ea2",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 19638.46,
                            "dataAssetId": "0197f5cc-4b9d-75c2-8019-eb5de0ae7ea2",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2024-06",
                    "value": 53764.130000000005,
                    "accounts": [
                        {
                            "value": -2214.92,
                            "dataAssetId": "0197f5cc-4b9d-75c2-8019-eb5de0ae7ea2",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 39464.24,
                            "dataAssetId": "0197f5cc-4b9d-75c2-8019-eb5de0ae7ea2",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 16514.81,
                            "dataAssetId": "0197f5cc-4b9d-75c2-8019-eb5de0ae7ea2",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2024-07",
                    "value": 57020.17,
                    "accounts": [
                        {
                            "value": -699.4,
                            "dataAssetId": "0197f5cc-4b9d-75c2-8019-eb5de0ae7ea2",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 40882.01,
                            "dataAssetId": "0197f5cc-4b9d-75c2-8019-eb5de0ae7ea2",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 16837.56,
                            "dataAssetId": "0197f5cc-4b9d-75c2-8019-eb5de0ae7ea2",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2024-08",
                    "value": 1212828.8199999998,
                    "accounts": [
                        {
                            "value": -1854,
                            "dataAssetId": "019854f3-6f81-7143-908e-fe5ac4a7ada5",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 78142.65,
                            "dataAssetId": "019854f3-6f81-7143-908e-fe5ac4a7ada5",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": -28.36,
                            "dataAssetId": "019854f3-6f81-7143-908e-fe5ac4a7ada5",
                            "accountId": "0197f5cb-f91a-7103-9854-c09f2f1592eb",
                            "accountName": "Shipping Revenue-264",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 20741.32,
                            "dataAssetId": "019854f3-6f81-7143-908e-fe5ac4a7ada5",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 63700,
                            "dataAssetId": "019854f3-6f81-7143-908e-fe5ac4a7ada5",
                            "accountId": "019810a2-5dd7-7540-a0a2-f2610febcca4",
                            "accountName": "Gross Sales - Consigned-262",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 1052127.21,
                            "dataAssetId": "019854f3-6f81-7143-908e-fe5ac4a7ada5",
                            "accountId": "019810a2-5dd8-77e1-b7f1-6906f91d95bd",
                            "accountName": "Gross Sales-259",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2024-09",
                    "value": 1310645.84,
                    "accounts": [
                        {
                            "value": -44736.79,
                            "dataAssetId": "0198e510-8a7a-7962-8a9f-e8c613ab65ed",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 76336.2,
                            "dataAssetId": "0198e510-8a7a-7962-8a9f-e8c613ab65ed",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 16751.61,
                            "dataAssetId": "0198e510-8a7a-7962-8a9f-e8c613ab65ed",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 35265,
                            "dataAssetId": "0198e510-8a7a-7962-8a9f-e8c613ab65ed",
                            "accountId": "019810a2-5dd7-7540-a0a2-f2610febcca4",
                            "accountName": "Gross Sales - Consigned-262",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 1227029.82,
                            "dataAssetId": "0198e510-8a7a-7962-8a9f-e8c613ab65ed",
                            "accountId": "019810a2-5dd8-77e1-b7f1-6906f91d95bd",
                            "accountName": "Gross Sales-259",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2024-10",
                    "value": 1992038.8699999999,
                    "accounts": [
                        {
                            "value": -13029.92,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 121142.09,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 29673.51,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 32505,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "019810a2-5dd7-7540-a0a2-f2610febcca4",
                            "accountName": "Gross Sales - Consigned-262",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 1821748.19,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "019810a2-5dd8-77e1-b7f1-6906f91d95bd",
                            "accountName": "Gross Sales-259",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2024-11",
                    "value": 3168315.1799999997,
                    "accounts": [
                        {
                            "value": -22689.76,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 174622.42,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 32049.43,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 205675,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "019810a2-5dd7-7540-a0a2-f2610febcca4",
                            "accountName": "Gross Sales - Consigned-262",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 2778658.09,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "019810a2-5dd8-77e1-b7f1-6906f91d95bd",
                            "accountName": "Gross Sales-259",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2024-12",
                    "value": 4392768.15,
                    "accounts": [
                        {
                            "value": -38404.28,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 229853.84,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 52014.2,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 158387,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "019810a2-5dd7-7540-a0a2-f2610febcca4",
                            "accountName": "Gross Sales - Consigned-262",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 3990917.39,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "019810a2-5dd8-77e1-b7f1-6906f91d95bd",
                            "accountName": "Gross Sales-259",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2025-01",
                    "value": 1200761.6500000001,
                    "accounts": [
                        {
                            "value": -22995.54,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 67388.21,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 52729.42,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 51981,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "019810a2-5dd7-7540-a0a2-f2610febcca4",
                            "accountName": "Gross Sales - Consigned-262",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 1051658.56,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "019810a2-5dd8-77e1-b7f1-6906f91d95bd",
                            "accountName": "Gross Sales-259",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2025-02",
                    "value": 1364382.34,
                    "accounts": [
                        {
                            "value": -10890.5,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 76503.06,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 32589,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 37925,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "019810a2-5dd7-7540-a0a2-f2610febcca4",
                            "accountName": "Gross Sales - Consigned-262",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 1228255.78,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "019810a2-5dd8-77e1-b7f1-6906f91d95bd",
                            "accountName": "Gross Sales-259",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2025-03",
                    "value": 1520812.98,
                    "accounts": [
                        {
                            "value": -6309.11,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 77884.8,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 34350.21,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 104310,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "019810a2-5dd7-7540-a0a2-f2610febcca4",
                            "accountName": "Gross Sales - Consigned-262",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 1310577.12,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "019810a2-5dd8-77e1-b7f1-6906f91d95bd",
                            "accountName": "Gross Sales-259",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": -0.04,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "019810a2-5dd8-77e1-b7f1-691e21cdd9a1",
                            "accountName": "Small Balances Write-off-1803",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2025-04",
                    "value": 725728.68,
                    "accounts": [
                        {
                            "value": -2839.13,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 37759.66,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 20664.61,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 38610,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "019810a2-5dd7-7540-a0a2-f2610febcca4",
                            "accountName": "Gross Sales - Consigned-262",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 631533.54,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "019810a2-5dd8-77e1-b7f1-6906f91d95bd",
                            "accountName": "Gross Sales-259",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2025-05",
                    "value": 1109925.08,
                    "accounts": [
                        {
                            "value": -2180.05,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 55720.79,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 15447.69,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 101618,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "019810a2-5dd7-7540-a0a2-f2610febcca4",
                            "accountName": "Gross Sales - Consigned-262",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 939318.65,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "019810a2-5dd8-77e1-b7f1-6906f91d95bd",
                            "accountName": "Gross Sales-259",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2025-06",
                    "value": 766311.16,
                    "accounts": [
                        {
                            "value": -14631.6,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 39837.96,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 19735.49,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 42269,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "019810a2-5dd7-7540-a0a2-f2610febcca4",
                            "accountName": "Gross Sales - Consigned-262",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 679100.31,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "019810a2-5dd8-77e1-b7f1-6906f91d95bd",
                            "accountName": "Gross Sales-259",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2025-07",
                    "value": 665594.8200000001,
                    "accounts": [
                        {
                            "value": -2805.77,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 38132.78,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 15089.81,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 34650,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "019810a2-5dd7-7540-a0a2-f2610febcca4",
                            "accountName": "Gross Sales - Consigned-262",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 580528,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "019810a2-5dd8-77e1-b7f1-6906f91d95bd",
                            "accountName": "Gross Sales-259",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                },
                {
                    "period": "2025-08",
                    "value": 1307586.01,
                    "accounts": [
                        {
                            "value": -2403.43,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f907-7152-9866-a920a16ce999",
                            "accountName": "Sales Discounts-260",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 79108.27,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f90f-7581-9a64-20604828fbb8",
                            "accountName": "Shipping & Handling-108",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 17869.52,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "0197f5cb-f92c-7361-9953-f78f915166a5",
                            "accountName": "Sales Returns & Refunds-261",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 26910,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "019810a2-5dd7-7540-a0a2-f2610febcca4",
                            "accountName": "Gross Sales - Consigned-262",
                            "accountLabel": "revenues.cohort"
                        },
                        {
                            "value": 1186101.65,
                            "dataAssetId": "01990923-206a-7782-9674-9d323e4b775d",
                            "accountId": "019810a2-5dd8-77e1-b7f1-6906f91d95bd",
                            "accountName": "Gross Sales-259",
                            "accountLabel": "revenues.cohort"
                        }
                    ]
                }
            ]
        }
    ]
}
